import * as React from 'react'
import { Box } from "@mui/material"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"

import { useAdminSkuTable } from "../../@hooks"


export default function viewMappingsColumn() {
    return {
        name: "skuID", label: "View Mappings",
        options: {
            headerAlign: "center",
            filter: false,
            sort: false,
            customBodyRowRenderLite: value => <Cell skuID={value} />
        }
    }
}

const Cell = ({ skuID }) => {
    const { isClicked, isLoadingViewMapping, handleClickViewMapping } = useAdminSkuTable(skuID)

    let className = ""
    if (isClicked) {
        className = "is-clicked"
        if (isLoadingViewMapping)
            className = "is-loading"
    }

    return <Box display="flex" justifyContent="center" className={className} minWidth={200}>
        <ButtonLoadingSeeker
            startIcon={<IconSeeker icon="sitemap" />}
            loading={isLoadingViewMapping}
            onClick={handleClickViewMapping}
        >
            View Mappings
        </ButtonLoadingSeeker>
    </Box>
}